import React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import noAssests from "./../../../assets/baseVersion/Group.svg";

interface AgentListEmptyStateProps {
  onAddAgent: () => void;
}

const AgentListEmptyState: React.FC<AgentListEmptyStateProps> = ({ onAddAgent }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        width: '100%',
        minHeight: 0,
        textAlign: 'center',
        bgcolor: isDarkMode ? theme.palette.background.default : '#FAFBFC',
        gap: 2,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <img
          src={noAssests}
          alt="No data available"
          style={{ maxWidth: "120px", height: "120px" }}
        />
      </Box>
      <Typography
        variant="body1"
        sx={{
          fontSize: '20px',
          fontWeight: 700,
        }}
      >
        There is no data available,
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        You have zero Agents. Configure an Agent by clicking
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        on ‘Create Agent’
      </Typography>
      <Button
        variant="outlined"
        onClick={onAddAgent}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '12px',
          padding: '6px 16px',
          borderColor: '#4640DE',
          color: '#4640DE',
          borderRadius: '6px',
          borderWidth: '1.5px',
          height: '28px',
          minWidth: 'auto',
          letterSpacing: '0.3px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            borderColor: '#3730CC',
            borderWidth: '1.5px',
            bgcolor: '#4640DE',
            color: '#fff',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 8px rgba(70, 64, 222, 0.25)',
          },
          '&:active': {
            transform: 'translateY(0px)',
          },
        }}
      >
        Create Agent
      </Button>
    </Box>
  );
};

export default AgentListEmptyState;
